import React from 'react'

const DisplayPriceUiDefault = (props) => {
    return (
        <React.Fragment>
            {/************************* PINTAMOS PRECIOS **********************************/}
            {props.hasDiscount ? (
                <React.Fragment>
                    {props.showOldPrice && (
                        <React.Fragment>
                            <del>
                                {props.showTotalPriceByQty > 0 ? props.totalPrice : props.price}&nbsp; {/*PRECIO NORMAL O PRECIO POR CANTIDAD*/}
                                {props.displayPriceWithoutMeasure ? props.priceFormatWithoutMeasure : props.priceFormat}
                            </del>
                            <br />
                        </React.Fragment>
                    )}
                    <span className='text price'>
                        {props.discountPrice}&nbsp; {/*PRECIO DESCUENTO*/}
                        {props.discountFormat} {/*FORMATO DESCUENTO*/}
                    </span>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <span className='text price'>
                        {props.showTotalPriceByQty > 0 ? props.totalPrice : props.price}&nbsp; {/*PRECIO NORMAL O PRECIO POR CANTIDAD*/}
                        {props.displayPriceWithoutMeasure ? props.priceFormatWithoutMeasure : props.priceFormat}
                    </span>
                </React.Fragment>
            )}
            {/********************************************************************************/}
        </React.Fragment>
    )
}

export default DisplayPriceUiDefault